import { SnackBarStatusSlice } from "./snackbar-message-slice";

export const { setStatus, clearSetStatus } = SnackBarStatusSlice.actions;

export default SnackBarStatusSlice.reducer;
